import { ClientService } from './client-service';
import { OrderAdjustmentOrderItem } from './order-adjustment-order-item';

export class ClientServiceAdjustmentOrderItem extends OrderAdjustmentOrderItem {
  clientService: ClientService = null;
}
